import React from 'react';
import logoIglesia from '../../assets/images/logo-oficial.png';
import { usePublicContent } from '../../hooks/usePublicContent';

export const Footer: React.FC = () => {
  const { getText, getImage, getJson } = usePublicContent('FOOTER');

  const logoUrl = getImage('brand', 'logo_url', logoIglesia);
  const churchName = getText('brand', 'nombre', 'Iglesia Cristiana Cuadrangular');
  const churchSubtitle = getText('brand', 'subtitulo', 'Central de Apartadó');
  const description = getText('brand', 'descripcion', 'Una iglesia donde el amor de Cristo transforma vidas y familias para la gloria de Dios. Predicamos el evangelio completo: Jesucristo Salva, Sana, Bautiza con el Espíritu Santo y Viene Otra Vez.');
  const addressLabel = getText('contacto', 'direccion_label', 'Dirección:');
  const address = getText('contacto', 'direccion', 'Calle 101 # 98 - 53\nBarrio Chinita, Apartadó, Colombia');
  const emailLabel = getText('contacto', 'email_label', '✉️ Email:');
  const email = getText('contacto', 'email', 'info@iccapartado.org');
  const horariosLabel = getText('horarios', 'label', '🕐 Horarios de Servicio');
  const horarios = getJson<{ dia: string; hora: string }[]>('horarios', 'items', [
    { dia: 'Dom', hora: '7:00 AM - 9:30 AM' },
    { dia: 'Mié', hora: '7:00 PM' },
    { dia: 'Sáb', hora: '6:30 PM (Juvenil)' },
  ]);
  const socialLabel = getText('social', 'label', 'Síguenos:');
  const socialLinks = getJson<{ nombre: string; url: string; color: string }[]>('social', 'links', [
    { nombre: 'Facebook', url: 'https://www.facebook.com/ICCuadrangularCentraldeApartado?locale=es_LA', color: 'bg-blue-600' },
    { nombre: 'WhatsApp', url: 'https://www.whatsapp.com/channel/0029Vb6q5zf17EmzSvIdZC2k', color: 'bg-green-600' },
    { nombre: 'Instagram', url: 'https://instagram.com/icc_apartado', color: 'bg-gradient-to-r from-pink-500 to-purple-600' },
  ]);
  const copyright = getText('copyright', 'texto', '&copy; 2026 Iglesia Cristiana Cuadrangular Central de Apartadó. Todos los derechos reservados.');
  const credits = getText('copyright', 'creditos', 'Desarrollado con ❤️ para la gloria de Dios');

  const renderSocialIcon = (name: string) => {
    if (name.toLowerCase().includes('facebook')) {
      return (
        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      );
    }
    if (name.toLowerCase().includes('whatsapp')) {
      return (
        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.567-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.50 3.488"/>
        </svg>
      );
    }
    return (
      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    );
  };

  return (
    <footer className={`py-12 px-6 ${
      'bg-stone-100 text-stone-800'
    }`}>
      <div className="max-w-none mx-auto px-8">
        
        {/* Sección principal del footer */}
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-8">
          
          {/* Logo y Descripción */}
          <div className="lg:col-span-2 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-4 mb-4">
              <div className={`hidden md:block relative w-16 h-16 rounded-xl overflow-hidden transition-all duration-300 ${
                'bg-white shadow-md ring-1 ring-stone-200'
              }`}>
                <img 
                  src={logoUrl} 
                  alt={churchName} 
                  className="w-full h-full object-contain p-1"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white/5 pointer-events-none"></div>
              </div>
              <div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-1 leading-tight">
                  {churchName}
                </h3>
                <p className={`text-sm font-medium ${
                  'text-stone-500'
                }`}>
                  {churchSubtitle}
                </p>
              </div>
            </div>
            
            <p className={`text-sm leading-relaxed max-w-2xl mx-auto md:mx-0 ${
              'text-stone-600'
            }`}>
              {description}
            </p>
            
            {/* Redes Sociales */}
            <div className="mt-5">
              <p className="font-semibold mb-3 text-sm text-stone-600">{socialLabel}</p>
              <div className="flex gap-3 justify-center md:justify-start">
                {socialLinks.map((link) => (
                  <a
                    key={link.nombre}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 rounded-lg flex items-center justify-center hover:opacity-90 transition-colors group ${link.color}`}
                    title={link.nombre}
                  >
                    {renderSocialIcon(link.nombre)}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Información de Contacto */}
          <div className="text-center md:text-left">
            <h4 className={`text-lg font-serif font-bold mb-4 flex items-center justify-center md:justify-start gap-2 ${
              'text-stone-800'
            }`}>
              📍 <span>{getText('contacto', 'titulo', 'Contáctanos')}</span>
            </h4>
            
            <div className={`space-y-3 text-sm ${
              'text-stone-600'
            }`}>
              <div>
                <p className="font-semibold mb-1">{addressLabel}</p>
                <p className="leading-relaxed whitespace-pre-line">
                  {address}
                </p>
              </div>
              

              <div>
                <p className="font-semibold mb-1">{emailLabel}</p>
                <a 
                  href={`mailto:${email}`} 
                  className={`hover:underline transition-colors ${
                    'text-purple-700 hover:text-purple-800'
                  }`}
                >
                  {email}
                </a>
              </div>
            </div>
          </div>

          {/* Horarios */}
          <div className="text-center md:text-left">
            <h4 className={`text-lg font-serif font-bold mb-4 flex items-center justify-center md:justify-start gap-2 ${
              'text-stone-800'
            }`}>
              🕐 <span>{horariosLabel.replace('🕐 ', '')}</span>
            </h4>
            
            <div className={`text-sm ${
              'text-stone-600'
            }`}>
              <p className="font-semibold mb-2">Servicios:</p>
              <div className="space-y-1">
                {horarios.map((h) => (
                  <p key={h.dia}><strong>{h.dia}:</strong> {h.hora}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Separador y Copyright */}
        <div className={`pt-8 border-t ${
          'border-stone-300'
        }`}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className={`text-sm ${
              'text-stone-500'
            }`}>
              {copyright}
            </p>
            <div className={`text-xs ${
              'text-stone-400'
            }`}>
              {credits}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;